import { INameplateCard as IContentfulNameplateCard } from 'marketing-site/@types/generated/contentful'
import { IProps as INameplateCard } from 'marketing-site/src/mvp/library/elements/NameplateCard'
import { transformImage } from 'marketing-site/src/transformers/elements/ContentfulImage'
import { transformTextLink } from './ContentfulTextLink'

export function transformNamePlateCard({ fields }: IContentfulNameplateCard): INameplateCard {
  return {
    ...fields,
    image: transformImage(fields.image),
    bioLink: fields.textLink && transformTextLink(fields.textLink),
  }
}
